import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import SystemLoadingOverlay from './SystemLoadingOverlay';

const InternalSystemWrapper = ({ system, children }) => {
  const [minElapsed, setMinElapsed] = useState(false);

  // Mostrar el overlay al menos un breve lapso para dar experiencia corporativa
  useEffect(() => {
    const t = setTimeout(() => setMinElapsed(true), 900);
    return () => clearTimeout(t);
  }, [system.id]);

  const showOverlay = !minElapsed;

  return (
    <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
      {showOverlay && (
        <SystemLoadingOverlay
          title={`Cargando ${system.title}`}
          subtitle="Preparando tu espacio..."
          color={system.color || "#6C4DE2"}
        />
      )}
      {children}
    </Box>
  );
};

export default InternalSystemWrapper;
